import { Injectable } from 'angular-ts-decorators';

import { Domain } from '@shared/app/scripts/services/domain';
import { Settings } from '@core/app/scripts/services/settings';
import { SettingsManager } from '@shared/app/scripts/services/settings-manager';

/**
 * Service that exposes simple methods to get content from upload directory
 */
@Injectable('feeds')
export class Feeds {
  constructor(
    private $http: ng.IHttpService,
    private domain: Domain,
    private settings: Settings,
    private settingsManager: SettingsManager,
  ) {
    'ngInject';
  }

  /**
   * Read file & return as object of provided constructor.
   * @param {string} fileName file to be downloaded
   * @param {method} TConstructor constructor to create T object. Optional,
   * default to Object.
   * @param {string} tenantId to be provided for using non current tenant.
   * Optional.
   * @return {Promise}
   * Resolves with object of provided type or rejects with error.
   */
  getJson<T = Object>(
    fileName: string,
    TConstructor: new (...args: any[]) => T,
    tenantId?: string,
  ): ng.IPromise<T> {
    const downloadFrom = (uploadDirectory) => {
      const baseUrl = `//${this.domain.createSibling(
        'feeds',
      )}/${uploadDirectory}`;

      return this.$http.get(`${baseUrl}/${fileName}`).then((data) => {
        return new TConstructor(data.data);
      });
    };

    if (tenantId) {
      return this.settings.getTenant(tenantId).then((settings) => {
        return downloadFrom(settings.uploadDirectory);
      });
    } else {
      return downloadFrom(this.settingsManager.settings.uploadDirectory);
    }
  }
}
